import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Contract } from "@/types/contract";

interface PropertyLinksProps {
  contract: Contract;
}

export function PropertyLinks({ contract }: PropertyLinksProps) {
  // Only render if there are links to show
  if (!contract.realtor_com_link && !contract.zillow_com_link && !contract.county_assessor_link) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Property Resources</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {contract.realtor_com_link && (
          <div>
            <span className="font-medium">Realtor.com:</span>
            <p className="break-all">{contract.realtor_com_link}</p>
          </div>
        )}
        {contract.zillow_com_link && (
          <div>
            <span className="font-medium">Zillow:</span>
            <p className="break-all">{contract.zillow_com_link}</p>
          </div>
        )}
        {contract.county_assessor_link && (
          <div>
            <span className="font-medium">County Assessor:</span>
            <p className="break-all">{contract.county_assessor_link}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}